<template>
    <div>
        <el-dialog
            :visible.sync="membershipDialog.show"
            width="800px"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            append-to-body
            :show-close="false"
            custom-class="membership-dialog"
            :before-close="handleClose"
        >
            <iframe v-if="membershipDialog.show" :src="iframeUrl" frameborder="0"></iframe>
        </el-dialog>
        <el-dialog
            custom-class="agreement-dialog"
            :title="agreementDialog.title"
            :visible.sync="agreementDialog.show"
            :width="agreementDialog.width || '800px'"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            append-to-body
        >
            <iframe
                :style="{
                    height: agreementDialog.height || '500px'
                }"
                :src="agreementDialog.url"
                frameborder="0"
            ></iframe>
        </el-dialog>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {getAutologinandredirectUrl, getRedirectUrl} from '@/util/util';

export default {
    name: 'MembershipDialog',
    props: {
        materialguid: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            agreementDialog: {
                show: false,
                title: '',
                url: '',
                width: '800px',
                height: '540px'
            }
        };
    },
    computed: {
        ...mapGetters(['membershipDialog', 'userInfo']),
        iframeUrl() {
            if (!this.membershipDialog.show) {
                return '';
            }

            const params = {
                materialguid: this.materialguid || this.membershipDialog.materialguid || '',
                userguid: this.userInfo.userguid || '',
                prefectureguid: '',
                promocode: this.membershipDialog.promocode || '',
                issetdefault: this.membershipDialog.issetdefault ? '1' : '0'
            };

            let redirecturl = getRedirectUrl(window.Config.membershipDialogUrl, params);

            return getAutologinandredirectUrl({
                redirecturl,
                userguid: this.userInfo.userguid
            });
        }
    },
    mounted() {
        window.addEventListener('message', this.handleIframeMessage);
        window.openAgreementDialog = this.openAgreementDialog;
    },
    beforeDestroy() {
        window.openAgreementDialog = null;
        window.removeEventListener('message', this.handleIframeMessage);
    },
    methods: {
        ...mapActions(['getUserInfo', 'openMembershipDialog', 'closeMembershipDialog']),
        handleClose() {
            this.getUserInfo();
            this.closeMembershipDialog();
        },
        handleIframeMessage(event) {
            if (event.data.type === 'CLOSE_MEMBERSHIP_DIALOG' || event.data.type === 'CLOSE_PAY_DIALOG') {
                this.handleClose();
            }
        },
        openAgreementDialog(options) {
            this.agreementDialog.show = true;
            this.agreementDialog.title = options.title;
            this.agreementDialog.url = options.url;
            this.agreementDialog.width = options.width;
            this.agreementDialog.height = options.height;
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep {
    .agreement-dialog,
    .membership-dialog {
        height: 540px;

        .el-dialog__header {
            display: none;
        }

        .el-dialog__body {
            padding: 0;

            iframe {
                width: 100%;
                height: 100%;
                border: none;
            }
        }
    }

    .agreement-dialog {
        height: auto;

        .el-dialog__header {
            display: block;
        }
    }
}
</style>
